// extracted by mini-css-extract-plugin
export default {"label":"text-field_label__Da4u3","input":"text-field_input__S1zzq","readonly":"text-field_readonly__AgJbS"};